import { render, staticRenderFns } from "./NavModule.vue?vue&type=template&id=16899415"
import script from "./NavModule.vue?vue&type=script&lang=js"
export * from "./NavModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/alidata/server/jenkins/workspace/sunion-prod-web-os/03SRC/web-os/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16899415')) {
      api.createRecord('16899415', component.options)
    } else {
      api.reload('16899415', component.options)
    }
    module.hot.accept("./NavModule.vue?vue&type=template&id=16899415", function () {
      api.rerender('16899415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/layout/NavModule.vue"
export default component.exports